<template>
    <edit-dialog title="新增节假日" :show="show" @close="onClose" width="500px">
        <el-form :model="modelData" label-width="100px" :rules="validRules" ref="frm">
            <el-form-item prop="Year" label="年">
                <el-select v-model="modelData.Year">
                    <el-option v-for="item in yearList" :key="item" :label="item + ' 年'" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="Name" label="名称">
                <el-input v-model="modelData.Name" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="BeginDate" label="开始日期">
                <el-date-picker type="date" v-model="modelData.BeginDate"></el-date-picker>
            </el-form-item>
            <el-form-item prop="EndDate" label="结束日期">
                <el-date-picker type="date" v-model="modelData.EndDate"></el-date-picker>
            </el-form-item>
        </el-form>
        <template v-slot:button>
            <el-button type="success" @click="saveData"> 保存 </el-button>
            <el-button type="info" @click="onClose"> 取消 </el-button>
        </template>
    </edit-dialog>
</template>
<script>
export default {
    components: {},
    name: "AddHoliday",
    data() {
        return {
            yearList: [],
            modelData: {
                Year: 2021,
                Name: "",
                BeginDate: "",
                EndDate: "",
            },
            validRules: {
                Year: [
                    {
                        required: true,
                        message: "请选择年份",
                        trigger: "change",
                    },
                ],
                Name: [
                    {
                        required: true,
                        message: "请填写名称",
                        trigger: "blur",
                    },
                ],
                BeginDate: [
                    {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "change",
                    },
                ],
                EndDate: [
                    {
                        required: true,
                        message: "请选择结束日期",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    created() {
        let date = new Date();
        let maxYear = date.getFullYear() + 1;
        let arr = [];
        for (let i = 2000; i <= maxYear; i++) {
            arr.push(i);
        }
        this.yearList = arr;
        this.modelData.Year = date.getFullYear();
    },
    props: {
        show: { type: Boolean, default: false },
    },
    methods: {
        onClose() {
            this.$emit("close");
        },
        saveData() {
            this.$refs.frm.validate((r) => {
                if (r) {
                    this.$emit("save", this.modelData);
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.inputText {
    width: 220px;
}
</style>
